'use client'

import { useState } from 'react'
import { NetworkTreeNode, UseTreeSearchResult } from './types'
import { getFilteredNodes } from './helpers'

export function useTreeSearch(data: NetworkTreeNode[]): UseTreeSearchResult {
  const [searchTerm, setSearchTerm] = useState('')
  const [isComposing, setIsComposing] = useState(false)

  const filteredItems = getFilteredNodes(data, searchTerm)
  const rootNodes = filteredItems.filter(node => !node.viewableParent)

  return {
    searchTerm,
    setSearchTerm,
    isComposing,
    setIsComposing,
    filteredItems,
    rootNodes
  }
}
